module.exports = __webpack_public_path__ + "media/customizations/sunterralakeslife/logo-99ec49c33e17ef9f72ada53e1dcd48eb.png";